/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_Row3_CostInputs */

const en_mk_model_row3_cost = /** @type {(inputs: Mk_Model_Row3_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≈ Rp6,500/report`)
};

const id_mk_model_row3_cost = /** @type {(inputs: Mk_Model_Row3_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≈ Rp6.500/laporan`)
};

/**
* | output |
* | --- |
* | "≈ Rp6,500/report" |
*
* @param {Mk_Model_Row3_CostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_row3_cost = /** @type {((inputs?: Mk_Model_Row3_CostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_Row3_CostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_row3_cost(inputs)
	return en_mk_model_row3_cost(inputs)
});